export { AuthHeroCarouselComponent } from '@catch/general-ui';
